import axios, { AxiosProgressEvent, CancelTokenSource } from 'axios'
import { Option, fromNullable } from 'fp-ts/lib/Option'

export interface UploadAttachmentResponse {
  path: string
  version: Option<string>
}

export interface AttachmentApi {
  upload(
    path: string,
    file: File,
    mimeType: string,
    cancelToken: CancelTokenSource,
    onUploadProgress: (e: AxiosProgressEvent) => void
  ): Promise<UploadAttachmentResponse>
}

export class AttachmentApiClient implements AttachmentApi {
  constructor(
    private readonly authProfile: string,
    private readonly attachmentsUrl: string
  ) {}

  public upload = (
    path: string,
    file: File,
    mimeType: string,
    cancelToken: CancelTokenSource,
    onUploadProgress: (e: AxiosProgressEvent) => void
  ): Promise<UploadAttachmentResponse> =>
    axios
      .put(this.attachmentsUrl + path, null, {
        cancelToken: cancelToken.token,
        headers: { 'Content-Type': mimeType },
        params: {
          'attachment-auth-profile': this.authProfile
        }
      })
      .then(({ data }) => {
        return axios.put(data.s3_url, file, {
          onUploadProgress,
          cancelToken: cancelToken.token,
          headers: {
            'Content-Type': mimeType
          },
          // s3 response will be empty, and default json response type will
          // cause 'no root element found' XML parsing errors
          // (reproducible at least on firefox)
          responseType: 'text'
        })
      })
      .then(({ headers }) => ({
        path,
        version: fromNullable(headers['x-amz-version-id'])
      }))
}

export const api: (
  authProfile: string,
  attachmentsUrl: string
) => AttachmentApi = (authProfile: string, attachmentsUrl: string) =>
  new AttachmentApiClient(authProfile, attachmentsUrl)
